module.exports = __webpack_public_path__ + "assets/msg-9947a47fd4c59bf88d0d42575fe603f1.svg";